import React from 'react'

import {
  Icon, Dollar, InfoOutlined, SuccessOutlined,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

const FEATURES = [
  {
    icon: SuccessOutlined,
    labelKey: 'my_subscriptions.status_card.participation_label',
    textKey: 'my_subscriptions.status_card.participation_text',
  },
  {
    icon: Dollar,
    labelKey: 'my_subscriptions.status_card.revenue_share_label',
    textKey: 'my_subscriptions.status_card.revenue_share_text',
  },
  {
    icon: InfoOutlined,
    labelKey: 'my_subscriptions.status_card.manage_label',
    textKey: 'my_subscriptions.status_card.manage_text',
  },
]

function ProgramFeaturesList({ translate, className }) {
  return (
    <ul className={className}>
      {FEATURES.map(({ icon, labelKey, textKey }) => (
        <li key={labelKey} className="program-features-list__item">
          <Icon svgComponent={icon} size="small" color="primary" />
          <span className="cgt-text-medium">
            <strong>{translate(labelKey)}</strong> {translate(textKey)}
          </span>
        </li>
      ))}
    </ul>
  )
}

ProgramFeaturesList.propTypes = {
  translate: func.isRequired,
  className: string,
}

export default ProgramFeaturesList
